<table class="table participants">
    <thead>
        <tr>
            <th></th>
            <th>{{ 'form.participants' | translate }}</th>
            <th>{{ 'form.name-and-surname' | translate }}</th>
            <th class="d-none d-md-table-cell">
                {{ 'form.document' | translate }}
            </th>
            <th class="d-none d-md-table-cell">
                {{ 'form.phone' | translate }}
            </th>
            <th class="d-none d-md-table-cell">
                {{ 'form.condition' | translate }}
            </th>
        </tr>
    </thead>
    <tbody>
        <ng-template ngFor let-pupil [ngForOf]="pupils" let-isFirst="first">
            <ng-container>
                <tr>
                    <td [ngSwitch]="pupil.type">
                        <i class="icon-minor-plus" *ngSwitchCase="ClientType.MINOR"></i>
                        <i class="icon-disabled-plus" *ngSwitchDefault></i>
                    </td>
                    <td [ngSwitch]="pupil.relation">
                        <strong class="text-uppercase text-blue" *ngSwitchCase="ClientRelation.AUTHORIZED">{{
                            'form.authorized' | translate
                        }}</strong>
                        <strong class="text-uppercase text-blue" *ngSwitchDefault>
                            <ng-container *ngIf="pupil.isSoleHolder">{{ 'form.holder' | translate }}</ng-container>
                            <ng-container *ngIf="!pupil.isSoleHolder">{{ 'form.co-holder' | translate }}</ng-container>
                        </strong>
                    </td>
                    <td>
                        <strong>{{ pupil.name }}</strong
                        >&nbsp;<strong>{{ pupil.surname }}</strong>
                    </td>
                    <td class="d-none d-md-table-cell">
                        <strong>{{ pupil.docId }}</strong>
                    </td>
                    <td class="d-none d-md-table-cell">
                        <strong>{{ pupil.phone }}</strong>
                    </td>
                    <td class="d-none d-md-table-cell" [ngSwitch]="pupil.type">
                        <strong class="text-uppercase text-blue" *ngSwitchCase="ClientType.MINOR">
                            {{ 'form.minor-person' | translate }}
                        </strong>
                        <strong class="text-uppercase text-blue" *ngSwitchCase="ClientType.DISABLED">
                            {{ 'form.disabled-person' | translate }}
                        </strong>
                        <strong class="text-uppercase text-blue" *ngSwitchDefault> - </strong>
                    </td>
                </tr>
            </ng-container>
        </ng-template>
    </tbody>
</table>
